import { render, staticRenderFns } from "./CommonFormWithCompanyInformationEditor.vue?vue&type=template&id=bbc5deb4&lang=pug&"
import script from "./CommonFormWithCompanyInformationEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithCompanyInformationEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithCompanyInformationEditor.vue?vue&type=style&index=0&id=bbc5deb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports